import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import INFTProperties, { IBaseNFTAttributes } from '../../models/INFTProperties'
import { ILootFishCard } from '../Cards/LootFishCard'
import BaseDetail from './BaseDetail'


export default function LootFishDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<ILootFishCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri).then((tokenResult: any) => setDetailTokenItem(tokenResult))
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: INFTProperties[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes.map((item: IBaseNFTAttributes) => ({
        key: item.trait_type,
        value: item.value,
        show: true,
        isUrl: false
      }))
    }

    return result
  }

  function getNFTDescription() {
    return (
      <div>
        What are LootFish?
        <p>
          LootFish is a unique NFT collection on the Avalanche C Chain featuring 10000 beautiful and exotic fish. There
          are hundreds of species of exotic fish in the collection, from rainbowfish to anglers to barbs. LootFish run
          the whole gamut of marine life, with no two perfectly identical. Catch fish and burn them to earn AVAX, or
          raise them in a decked out mini-aquarium!
        </p>
      </div>
    )
  }

  const tokenName = detailTokenItem ? `${collection.name} #${tokenItem.tokenId}` : collection.name

  return (
    <BaseDetail
      {...props}
      description={getNFTDescription()}
      tokenItemName={tokenName}
      properites={getNFTProperties()}
      externalUrl={detailTokenItem?.externalUrl}
    >
      {detailTokenItem ? (
        <img className="pixelated-image" src={detailTokenItem.image} alt={tokenName} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
